function objectWithoutProperties(obj, exclude) {
  var target = {}
  for (var k in obj)
    if (
      Object.prototype.hasOwnProperty.call(obj, k) &&
      exclude.indexOf(k) === -1
    )
      target[k] = obj[k]
  return target
}
var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "p-property", style: { width: _vm.width } },
    [
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !!_vm.loading,
              expression: "!!loading"
            }
          ],
          staticClass: "loader u-stretch"
        },
        [_c("ui-loader", { staticClass: "ui-loader" })],
        1
      ),
      _vm._v(" "),
      _c(
        "a",
        {
          staticClass: "close cl-placeholder",
          attrs: { "aria-label": "閉じる" },
          on: {
            click: function($event) {
              return _vm.$popup.hide()
            }
          }
        },
        [_c("icon-close")],
        1
      ),
      _vm._v(" "),
      _c("h1", { staticClass: "h2 t-center" }, [_vm._v(_vm._s(_vm.title))]),
      _vm._v(" "),
      !_vm.type
        ? _c("div", { staticClass: "caption t12 t-center" }, [
            _vm._v("\n        物件種別を選択してください。\n    ")
          ])
        : _c("div", { staticClass: "caption t12 t-center" }, [
            _vm._v(
              "\n        物件の情報を入力し、保存するボタンをクリックしてください。\n    "
            )
          ]),
      _vm._v(" "),
      _c("ui-spinner", {
        directives: [
          {
            name: "show",
            rawName: "v-show",
            value: !!_vm.loading,
            expression: "!!loading"
          }
        ],
        staticClass: "spinner"
      }),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: !_vm.loading,
              expression: "!loading"
            }
          ],
          staticClass: "form"
        },
        [
          _c(
            "div",
            { staticClass: "row u-row" },
            [
              _c("span", { staticClass: "w5 label" }, [_vm._v("物件種別")]),
              _vm._v(" "),
              _c("ui-dropdown", {
                staticClass: "u-flex",
                scopedSlots: _vm._u([
                  {
                    key: "default",
                    fn: function(ref) {
                      var active = ref.active
                      var toggle = ref.toggle
                      return [
                        _c("ui-select", {
                          class: { active: active },
                          attrs: { label: _vm.type || "選択してください" },
                          nativeOn: {
                            click: function($event) {
                              return toggle($event)
                            }
                          }
                        }),
                        _vm._v(" "),
                        _c("ui-options", {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: active,
                              expression: "active"
                            }
                          ],
                          attrs: { options: _vm.types },
                          on: { update: _vm.select }
                        })
                      ]
                    }
                  }
                ])
              })
            ],
            1
          ),
          _vm._v(" "),
          _vm.type && _vm.model
            ? _c(
                "div",
                { staticClass: "fields" },
                [
                  _c(
                    "div",
                    { staticClass: "row half u-row" },
                    [
                      _c("span", { staticClass: "w5 label" }, [
                        _vm._v("募集･成約時期")
                      ]),
                      _vm._v(" "),
                      _c("ui-date", {
                        attrs: { value: _vm.model.dealtAt },
                        on: {
                          update: function($event) {
                            _vm.model.dealtAt = $event
                          }
                        }
                      }),
                      _vm._v(" "),
                      _c("span", { staticClass: "unit" })
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _vm._l(_vm.inputs, function(ref) {
                    var get = ref.get
                    var set = ref.set
                    var width = ref.width
                    var wrap = ref.wrap
                    var rest = objectWithoutProperties(ref, [
                      "get",
                      "set",
                      "width",
                      "wrap"
                    ])
                    var input = rest
                    return _c(
                      "div",
                      {
                        key: input.name,
                        staticClass: "row u-row",
                        class: { wrap: wrap },
                        style: {
                          width: width,
                          marginRight: wrap ? "calc(100% - " + width + ")" : 0
                        }
                      },
                      [
                        _c("span", { staticClass: "w5 label" }, [
                          _vm._v(_vm._s(input.label))
                        ]),
                        _vm._v(" "),
                        input.type === "select"
                          ? _c("ui-dropdown", {
                              staticClass: "u-flex",
                              scopedSlots: _vm._u(
                                [
                                  {
                                    key: "default",
                                    fn: function(ref) {
                                      var active = ref.active
                                      var toggle = ref.toggle
                                      return [
                                        _c("ui-select", {
                                          class: { active: active },
                                          attrs: {
                                            label:
                                              _vm.model[input.name] ||
                                              input.placeholder
                                          },
                                          nativeOn: {
                                            click: function($event) {
                                              return toggle($event)
                                            }
                                          }
                                        }),
                                        _vm._v(" "),
                                        _c("ui-options", {
                                          directives: [
                                            {
                                              name: "show",
                                              rawName: "v-show",
                                              value: active,
                                              expression: "active"
                                            }
                                          ],
                                          attrs: { options: input.options },
                                          on: {
                                            update: function($event) {
                                              _vm.model[input.name] = $event
                                            }
                                          }
                                        })
                                      ]
                                    }
                                  }
                                ],
                                null,
                                true
                              )
                            })
                          : input.type === "date"
                          ? _c("ui-date", {
                              attrs: { value: _vm.model[input.name] },
                              on: {
                                update: function($event) {
                                  _vm.model[input.name] = $event
                                }
                              }
                            })
                          : _c("input", {
                              staticClass: "i-box u-flex field",
                              attrs: {
                                type: input.type,
                                step: input.step || 1,
                                placeholder: input.placeholder
                              },
                              domProps: { value: get(_vm.model[input.name]) },
                              on: {
                                input: function($event) {
                                  _vm.model[input.name] = set(
                                    $event.target.value
                                  )
                                }
                              }
                            }),
                        _vm._v(" "),
                        input.unit
                          ? _c("span", { staticClass: "unit" }, [
                              _vm._v(_vm._s(input.unit))
                            ])
                          : _vm._e()
                      ],
                      1
                    )
                  })
                ],
                2
              )
            : _vm._e(),
          _vm._v(" "),
          _c("div", { staticClass: "u-row buttons" }, [
            _c(
              "a",
              {
                staticClass: "btn u-flex dark",
                on: {
                  click: function($event) {
                    return _vm.$popup.hide()
                  }
                }
              },
              [_vm._v("\n                閉じる\n            ")]
            ),
            _vm._v(" "),
            _c(
              "a",
              {
                staticClass: "btn u-flex primary",
                class: { inactive: !_vm.type },
                on: {
                  click: function($event) {
                    $event.stopPropagation()
                    return _vm.save($event)
                  }
                }
              },
              [_c("icon-save"), _vm._v(" "), _c("span", [_vm._v("保存する")])],
              1
            )
          ])
        ]
      )
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }